import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUpdateMenuVenuesRequest, IUpdateMenuVenuesResponse } from './types';

export const updateMenuVenues = async (
  menuId: string,
  requestBody: IUpdateMenuVenuesRequest,
): Promise<IUpdateMenuVenuesResponse> => {
  const body = JSON.stringify(requestBody);

  const response = await fetch(`${API_URL}/menus/${menuId}/link`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  });

  if (!response.ok) {
    throw new Error('Error updating linked venues');
  }

  return await response.json();
};
